module.exports = __webpack_public_path__ + "img/92.6.CODm.26d684c8.png";